import React from 'react';
import './styles.css';

export default function Loading() {
  return (
    <div className='box-master'>
      <div className="custom-loader"></div>
    </div>
  )
}
